/*
 * @FilePath: /mall-fe/src/hooks/useAreaCookie.ts
 * @Description:  地区相关hooks
 */
import { getAreaId } from 'api/user';
import { AREA_COOKIE_EXPORES, DEFAULT_COOKIE_AREASYSNO } from 'libs/cons';
import { MediaQueryContext, SiteContext } from 'libs/contexts';
import { strToObj } from 'libs/utils';
import { useContext, useEffect, useState } from 'react';

export default function useAreaCookie() {
  const site = useContext(SiteContext);
  const { isMobile } = useContext(MediaQueryContext);
  // 根据租户code 拼接cookie key
  const tenantCode = site?.tenantCode ?? 'pazc';
  const AREA_CODE_KEY = `${tenantCode}_area_code`;
  const AREA_SYS_NO_KEY = `${tenantCode}_area_sys_no`;
  const [areaCode, setAreaCode] = useState('');
  const [areaSysNo, setAreaSysNo] = useState(DEFAULT_COOKIE_AREASYSNO);

  const genDomain = () => {
    const host = location.hostname;
    const hostSplit = host.split('.');
    let domainStr = '';
    if (hostSplit.length >= 3) {
      hostSplit.shift();
      domainStr = `.${hostSplit.join('.')}`;
    } else {
      domainStr = host.indexOf('.') > 0 ? `.${host}` : host;
    }
    return domainStr;
  };

  function setCookie(key: string, value: any) {
    if (isNaN(value)) {
      console.error(`${key} --- ${value}`);
      return;
    }
    const expires = new Date(Date.now() + AREA_COOKIE_EXPORES * 3600 * 24 * 1000).toUTCString();
    document.cookie = `${key}=${
      value ?? ''
    }; domain=${genDomain()}; path=/; expires=${expires}; Secure; SameSite=None`;
  }

  function getCookieAreacode() {
    const cookie = strToObj(document.cookie);
    return cookie[AREA_SYS_NO_KEY];
  }
  function getCookieAreaSysNo() {
    const cookie = strToObj(document.cookie);
    return cookie[AREA_SYS_NO_KEY];
  }
  function getCookieAreaCode() {
    const cookie = strToObj(document.cookie);
    return cookie[AREA_CODE_KEY];
  }

  useEffect(() => {
    if (isMobile) return;
    const cookie = strToObj(document.cookie);
    if (!cookie[AREA_SYS_NO_KEY]) {
      (async () => {
        const areaData = await getAreaId();
        if (areaData?.code === 200 && areaData?.data) {
          setAreaCode(areaData?.data?.levelCode);
          setAreaSysNo(areaData?.data?.areaId);
          setCookie(AREA_CODE_KEY, areaData?.data?.levelCode);
          setCookie(AREA_SYS_NO_KEY, areaData?.data?.areaId);
        }
      })();
    } else {
      setAreaCode(cookie[AREA_CODE_KEY]);
      setAreaSysNo(cookie[AREA_SYS_NO_KEY]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // set Area info by cookie
  function setAreaObjByCookie() {
    if (isMobile) return;
    const cookie = strToObj(document.cookie);
    if (!cookie[AREA_SYS_NO_KEY]) {
      (async () => {
        const areaData = await getAreaId();
        if (areaData?.code === 200 && areaData?.data) {
          setAreaCode(areaData?.data?.levelCode);
          setAreaSysNo(areaData?.data?.areaId);
          setCookie(AREA_CODE_KEY, areaData?.data?.levelCode);
          setCookie(AREA_SYS_NO_KEY, areaData?.data?.areaId);
        }
      })();
    } else {
      setAreaCode(cookie[AREA_CODE_KEY]);
      setAreaSysNo(cookie[AREA_SYS_NO_KEY]);
    }
  }

  return {
    AREA_CODE_KEY,
    AREA_SYS_NO_KEY,
    areaCode,
    areaSysNo,
    setCookie,
    getCookieAreacode,
    getCookieAreaSysNo,
    setAreaObjByCookie,
    getCookieAreaCode,
  };
}
